import { Box } from '@mui/material'
import styled from 'styled-components'

export const MapToolBox = styled(Box)`
  z-index: 1;
  left: 23px;
  bottom: 56px;
  position: absolute;
  display: flex;
  flex-direction: column;
`

export default MapToolBox
